/*
  Nakshatra Essence recommendations for the Vedic Birth Chart results page.

  The calculator (vedic-birth-chart.js) is a compiled React bundle, so this script
  stays outside it: it watches #vedic-birth-chart, reads the Moon, Ascendant and Sun
  nakshatras out of the rendered results, and renders matching essence cards
  (plus the Nakshatra Wheel kit upsell) in its own container right after the calculator.

  Product data (title, image, price, description, availability) is fetched live
  from /products/<handle>.js, so edits in Shopify show up without touching this file.
*/
(function () {
  'use strict';

  var ROOT_ID = 'vedic-birth-chart';
  var MOUNT_ID = 'vedic-nakshatra-essences';

  // Upsell under the single-essence cards (SKU smk01). Swap the handle to change the offer.
  var SET_HANDLE = 'nakshatra-wheel-divination-kit';

  // Calculator nakshatra name -> product handle. Handles are mapped explicitly
  // because several don't match the nakshatra name in Shopify (Ashlesha's handle
  // is "pushya-nakshatra-essence"; Pushya's is "pushya-nakshatra-essence-1").
  var HANDLES = {
    'Ashwini': 'ashvini-nakshatra-essence',
    'Bharani': 'bharani-nakshatra-essence',
    'Krittika': 'krittika-nakshatra-essence',
    'Rohini': 'rohini-nakshatra-essence',
    'Mrigashira': 'mrigashira-nakshatra-essence',
    'Ardra': 'arda-nakshatra-essence',
    'Punarvasu': 'punarvasu-nakshatra-essence',
    'Pushya': 'pushya-nakshatra-essence-1',
    'Ashlesha': 'pushya-nakshatra-essence',
    'Magha': 'magha-nakshatra-essence',
    'Purva Phalguni': 'poorva-phalguni-nakshatra-essence',
    'Uttara Phalguni': 'uttara-phalguni-nakshatra-essence',
    'Hasta': 'hasta-nakshatra-essence',
    'Chitra': 'chitra-nakshatra-essence',
    'Swati': 'swati-nakshatra-essence',
    'Vishakha': 'vishakha-nakshatra-essence',
    'Anuradha': 'anuradha-nakshatra-essence',
    'Jyeshtha': 'jyestha-nakshatra-essence',
    'Mula': 'moola-nakshatra-essence',
    'Purva Ashadha': 'poorvashada-nakshatra-essence',
    'Uttara Ashadha': 'uttarashada-nakshatra-essence',
    'Shravana': 'shravana-nakshatra-essence',
    'Dhanishta': 'dhanishta-nakshatra-essence',
    'Shatabhisha': 'shatabhisha-nakshatra-essence',
    'Purva Bhadrapada': 'poorvabhadrapada-nakshatra-essence',
    'Uttara Bhadrapada': 'uttarabhadrapada-nakshatra-essence',
    'Revati': 'revati-nakshatra-essence'
  };

  var productCache = {};
  var lastKey = '';
  var timer = null;

  function text(el) {
    return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : '';
  }

  // A planet's row in the "Planet Positions" table: 4th cell's first line is the nakshatra.
  function readPlanet(root, planet) {
    var rows = root.querySelectorAll('table tbody tr');
    for (var i = 0; i < rows.length; i++) {
      var cells = rows[i].children;
      if (cells.length >= 4 && text(cells[0]).replace(/\(R\)/, '').trim() === planet) {
        return text(cells[3].firstElementChild);
      }
    }
    return '';
  }

  // "Ascendant (Lagna)" card: the "Nakshatra" label's sibling reads "Name (Pada n)".
  function readAscendant(root) {
    var headings = root.querySelectorAll('h2');
    for (var i = 0; i < headings.length; i++) {
      if (text(headings[i]).indexOf('Ascendant') !== 0) continue;
      var labels = headings[i].parentNode.querySelectorAll('span');
      for (var j = 0; j < labels.length; j++) {
        if (text(labels[j]) === 'Nakshatra') {
          return text(labels[j].nextElementSibling).replace(/\s*\(Pada.*$/, '');
        }
      }
    }
    return '';
  }

  function fetchProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) {
          if (!r.ok) throw new Error(handle + ' ' + r.status);
          return r.json();
        });
    }
    return productCache[handle];
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Short "about" blurb from the product description: drop HTML, cut off the
  // ingredient / boilerplate tail, then trim to whole sentences.
  function blurb(html, max) {
    var t = String(html || '').replace(/<[^>]*>/g, ' ').replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ').trim();
    var cut = t.search(/FIND YOUR BIRTH STAR|Contains:|Includes:|A portion of sales|These statements have not/i);
    if (cut > 0) t = t.slice(0, cut).trim();
    if (t.length <= max) return t;
    var out = '';
    var sentences = t.match(/[^.!?]+[.!?]+(\s|$)/g) || [t];
    for (var i = 0; i < sentences.length; i++) {
      if ((out + sentences[i]).length > max && out) break;
      out += sentences[i];
    }
    return out.trim();
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function firstAvailable(p) {
    for (var i = 0; i < p.variants.length; i++) if (p.variants[i].available) return p.variants[i];
    return null;
  }

  function card(p, opts) {
    var v = firstAvailable(p);
    var price = money(p.price);
    var img = p.featured_image ? '<img class="vne-img" src="' + esc(p.featured_image) + '" alt="' + esc(p.title) + '" loading="lazy">' : '';
    var button = v
      ? '<button type="button" class="vne-btn" data-variants="' + v.id + '">Add to Cart — ' + price + '</button>'
      : '<button type="button" class="vne-btn" disabled>Currently Sold Out</button>';
    return '<div class="vne-card' + (opts.set ? ' vne-card--set' : '') + '">' +
      img +
      '<div class="vne-body">' +
        (opts.eyebrow ? '<div class="vne-eyebrow">' + esc(opts.eyebrow) + '</div>' : '') +
        '<h3 class="vne-name"><a href="' + esc(p.url) + '">' + esc(opts.title || p.title) + '</a></h3>' +
        '<p class="vne-text">' + esc(blurb(p.description, opts.set ? 260 : 340)) + '</p>' +
        '<div class="vne-actions">' + button + '<a class="vne-link" href="' + esc(p.url) + '">Learn more</a></div>' +
      '</div></div>';
  }

  var CSS =
    '#' + MOUNT_ID + '{max-width:1152px;margin:0 auto;padding:0 16px 48px;font-family:"Libre Baskerville",Georgia,serif;color:#2c190f}' +
    '#' + MOUNT_ID + ' h2.vne-title{font-family:"IM Fell DW Pica",Georgia,serif;font-size:26px;font-weight:400;margin:0 0 6px;text-align:center}' +
    '#' + MOUNT_ID + ' .vne-sub{text-align:center;font-size:14px;color:#96654b;margin:0 0 24px}' +
    '#' + MOUNT_ID + ' .vne-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(300px,1fr));gap:24px;margin-bottom:24px}' +
    '#' + MOUNT_ID + ' .vne-card{background:#fff;border:1px solid rgba(193,170,137,.3);border-radius:12px;box-shadow:0 1px 3px rgba(0,0,0,.08);overflow:hidden;display:flex;flex-direction:column}' +
    '#' + MOUNT_ID + ' .vne-card--set{flex-direction:row;background:#fbf7f1}' +
    '#' + MOUNT_ID + ' .vne-img{width:100%;aspect-ratio:1/1;object-fit:cover;background:#fbf7f1;display:block}' +
    '#' + MOUNT_ID + ' .vne-card--set .vne-img{width:200px;flex-shrink:0;aspect-ratio:auto;height:auto}' +
    '#' + MOUNT_ID + ' .vne-body{padding:20px 24px 24px;display:flex;flex-direction:column;flex:1}' +
    '#' + MOUNT_ID + ' .vne-eyebrow{font-size:12px;letter-spacing:.08em;text-transform:uppercase;color:#96654b;margin-bottom:4px}' +
    '#' + MOUNT_ID + ' .vne-name{font-family:"IM Fell DW Pica",Georgia,serif;font-size:22px;font-weight:400;margin:0 0 10px}' +
    '#' + MOUNT_ID + ' .vne-name a{color:#2c190f;text-decoration:none}' +
    '#' + MOUNT_ID + ' .vne-text{font-size:14px;line-height:1.65;margin:0 0 16px;flex:1}' +
    '#' + MOUNT_ID + ' .vne-actions{display:flex;align-items:center;gap:16px;flex-wrap:wrap}' +
    '#' + MOUNT_ID + ' .vne-btn{padding:10px 18px;background:#996847;border:1px solid #996847;border-radius:8px;color:#fff;font:600 14px/1.2 inherit;font-family:inherit;cursor:pointer}' +
    '#' + MOUNT_ID + ' .vne-btn:hover:not(:disabled){background:#7f5538}' +
    '#' + MOUNT_ID + ' .vne-btn:disabled{background:rgba(153,104,71,.15);border-color:rgba(153,104,71,.3);color:#96654b;cursor:default}' +
    '#' + MOUNT_ID + ' .vne-link{font-size:14px;color:#996847}' +
    '#' + MOUNT_ID + ' .vne-addall{text-align:center;margin:-4px 0 32px}' +
    '#' + MOUNT_ID + ' .vne-addall .vne-btn{padding:12px 24px;font-size:15px}' +
    '#' + MOUNT_ID + ' .vne-upsell-head{font-family:"IM Fell DW Pica",Georgia,serif;font-size:20px;text-align:center;margin:8px 0 12px}' +
    '#' + MOUNT_ID + ' .vne-fda{font-size:11px;color:#96654b;text-align:center;margin:20px 0 0}' +
    '@media(max-width:640px){#' + MOUNT_ID + ' .vne-card--set{flex-direction:column}#' + MOUNT_ID + ' .vne-card--set .vne-img{width:100%;aspect-ratio:1/1}}';

  function ensureStyle() {
    if (document.getElementById(MOUNT_ID + '-style')) return;
    var s = document.createElement('style');
    s.id = MOUNT_ID + '-style';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function getMount(root) {
    var m = document.getElementById(MOUNT_ID);
    if (!m) {
      m = document.createElement('div');
      m.id = MOUNT_ID;
      root.parentNode.insertBefore(m, root.nextSibling);
      m.addEventListener('click', onClick);
    }
    return m;
  }

  // Add one or more variants, then open the theme's cart drawer so the
  // customer stays on the page with their chart and the other cards intact.
  // (Same events sm-fbt.liquid uses.) Falls back to the cart page if the theme
  // has no drawer.
  function onClick(e) {
    var btn = e.target.closest && e.target.closest('.vne-btn[data-variants]');
    if (!btn || btn.disabled) return;
    var items = btn.getAttribute('data-variants').split(',').map(function (id) {
      return { id: Number(id), quantity: 1 };
    });
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart ' + r.status);
      btn.textContent = 'Added ✓';
      if (document.querySelector('cart-drawer')) {
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
      } else {
        window.location.href = '/cart';
      }
      setTimeout(function () {
        btn.disabled = false;
        btn.textContent = label;
      }, 2000);
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = label;
      alert('Sorry, we could not add that to your cart. Please try again.');
    });
  }

  // Eyebrow text for a card, from the placements that share its nakshatra.
  var SINGLE_EYEBROW = {
    Moon: 'Your Moon Nakshatra (Janma Nakshatra)',
    Ascendant: 'Your Ascendant (Lagna) Nakshatra',
    Sun: 'Your Sun Nakshatra'
  };

  function render(root, placements) {
    var mount = getMount(root);
    // One card per distinct nakshatra, in Moon, Ascendant, Sun order. When
    // placements land in the same nakshatra they share a card ("Moon & Sun").
    var picks = [];
    placements.forEach(function (pl) {
      if (!pl.name) return;
      var existing = picks.filter(function (p) { return p.name === pl.name; })[0];
      if (existing) existing.roles.push(pl.role);
      else picks.push({ name: pl.name, roles: [pl.role] });
    });
    picks.forEach(function (p) {
      p.eyebrow = p.roles.length === 1
        ? SINGLE_EYEBROW[p.roles[0]]
        : 'Your ' + p.roles.slice(0, -1).join(', ') + ' & ' + p.roles[p.roles.length - 1] + ' Nakshatra';
    });

    var wanted = picks.filter(function (p) { return HANDLES[p.name]; });
    if (!wanted.length) { mount.innerHTML = ''; return; }

    Promise.all(wanted.map(function (p) {
      return fetchProduct(HANDLES[p.name]).then(function (prod) { return { pick: p, prod: prod }; }, function () { return null; });
    }).concat(fetchProduct(SET_HANDLE).then(function (prod) { return prod; }, function () { return null; })))
      .then(function (results) {
        var setProd = results.pop();
        var cards = results.filter(Boolean);
        if (!cards.length) { mount.innerHTML = ''; return; }
        ensureStyle();
        var html = '<h2 class="vne-title">Your Nakshatra Essences</h2>' +
          '<p class="vne-sub">Star remedies matched to your birth chart.</p>' +
          '<div class="vne-grid">' +
          cards.map(function (c) {
            return card(c.prod, {
              eyebrow: c.pick.eyebrow + ' — ' + c.pick.name,
              title: c.prod.title
            });
          }).join('') + '</div>';
        var inStock = cards.map(function (c) { return firstAvailable(c.prod); }).filter(Boolean);
        if (inStock.length > 1) {
          var total = inStock.reduce(function (sum, v) { return sum + v.price; }, 0);
          var count = ['', '', 'both', 'all three'][inStock.length] || 'all ' + inStock.length;
          html += '<div class="vne-addall">' +
            '<button type="button" class="vne-btn" data-variants="' + inStock.map(function (v) { return v.id; }).join(',') + '">' +
              'Add ' + count + ' essences to cart — ' + money(total) + '</button>' +
            '</div>';
        }
        if (setProd) {
          html += '<div class="vne-upsell-head">Go deeper: track your planets on the Nakshatra Wheel</div>' +
            card(setProd, { set: true, eyebrow: 'The Divination Kit' });
        }
        html += '<p class="vne-fda">These statements have not been evaluated by the Food and Drug Administration. ' +
          'These products are not intended to diagnose, treat, cure or prevent any disease.</p>';
        mount.innerHTML = html;
      });
  }

  function update() {
    var root = document.getElementById(ROOT_ID);
    if (!root) return;
    var moon = readPlanet(root, 'Moon');
    var asc = readAscendant(root);
    var sun = readPlanet(root, 'Sun');
    if (!moon) {
      var m = document.getElementById(MOUNT_ID);
      if (m) m.innerHTML = '';
      lastKey = '';
      return;
    }
    var key = moon + '|' + asc + '|' + sun;
    if (key === lastKey) return;
    lastKey = key;
    render(root, [
      { role: 'Moon', name: moon },
      { role: 'Ascendant', name: asc },
      { role: 'Sun', name: sun }
    ]);
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(update, 150);
  }

  function init() {
    var root = document.getElementById(ROOT_ID);
    if (!root) return;
    new MutationObserver(schedule).observe(root, { childList: true, subtree: true, characterData: true });
    schedule();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
